import React, { Component, useState, useEffect, useContext } from "react";
import PaymentForm from "./PaymentForm";
import CheckoutForm from "./CheckoutForm";
import cx from "classnames";
import Button from "../../Button/Button";
import { Link, useHistory } from "react-router-dom";
import UserContext from "../../../store/UserContext"
import LoadingIcon from "../../Loading/LoadingIcon";


const WalletPayment = ({ booking, billingData, partialStatus, submitRef, setFailed, amountStatus, paymentPath, totalPrice, twentyPercentage, walletStatus, bookingID, paymentOptionID, backButtonFunction, normalBooking, bookingType, amount, handleWalletPayNow }) => {
    const [user, setUser] = useContext(UserContext)
    const [submitted, setSubmitted] = useState(false);
    const [clicked, setClicked] = useState(false);
    const [showCheckout, setShowCheckout] = useState(false);
    const [allowPayment, setAllowPayment] = useState(false);
    let history = useHistory();
    const onSubmit = (e) => {
        e.preventDefault();
        handleWalletPayNow()
        setClicked(true);
        if (submitRef && submitRef.current) submitRef.current.click();
    };

    useEffect(() => {
        console.log(partialStatus)
        console.log(totalPrice)
        console.log(amountStatus)
        if (partialStatus) {
            if (twentyPercentage > amountStatus) {
                setAllowPayment(false);
            } else {
                setAllowPayment(true);
            }
        } else {
            if (totalPrice > amountStatus) {
                setAllowPayment(false)
            } else {
                setAllowPayment(true)
            }
        }
    })

    useEffect(() => {
        if (paymentPath == "booking") {
            if (clicked && billingData) {
                setSubmitted(true)
                setClicked(false)
                setShowCheckout(true)
            }
        } else if (paymentPath == "wallet") {
            if (clicked) {
                setSubmitted(true)
                setClicked(false)
                setShowCheckout(true)
            }
        }
        // if (clicked && billingData) {
        //   setSubmitted(true);
        //   setClicked(false);
        //   setShowCheckout(true);
        // }
    }, [billingData, clicked]);

    const handleRecharge = () => {
        setUser(
            Object.assign({}, user, {
                rechargeStatus: true
            })
        )
        history.push("/admin/wallet");
    }

    return (
        <>
            {submitted ?
                <div className="bg-black opacity-80 z-10 flex flex-col items-center justify-center absolute top-0 bottom-0 left-0 right-0">
                    <i className="fas fa-spinner fa-pulse text-gigantic text-j-white" />
                    <p className="font-bold text-j-white text-huge">Transaction in progress.</p>
                    <p className="font-semibold text-j-white">Please do not refresh or navigate away from this page.</p>
                </div>
                : null
            }
            {allowPayment && <PaymentForm
                buttonText="Pay Amount"
                onSubmit={onSubmit}
                submitted={submitted}
            ></PaymentForm>}
            {!allowPayment && <>
                <p className="text-center text-j-orange text-sm">You dont have enough balance on your wallet please recharge</p>
                <Button
                    className="bg-j-red-light text-white w-full mt-4 pt-1"
                    onClick={() => handleRecharge()}
                >
                    Recharge Now
                </Button>
            </>}
            {showCheckout ? (
                <CheckoutForm
                    booking={booking}
                    paymentPath={paymentPath}
                    bookingID={bookingID}
                    billingData={billingData}
                    walletStatus={walletStatus}
                    partialStatus={partialStatus}
                    paymentOptionID={paymentOptionID}
                    wallet={true}
                    totalPrice={totalPrice}
                    normalBooking={normalBooking}
                    backButtonFunction={backButtonFunction}
                    bookingType={bookingType}
                    amount={amount}
                    cancel={(error) => {
                        setShowCheckout(false);
                        setSubmitted(false);
                        if (error) setFailed(error);
                    }}
                />
            ) : null}
        </>
    )
}


export default WalletPayment;